"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { installDevWakeRecoveryDebug } from "@/lib/client/devWakeRecoveryDebug";

/** Installs `window.__sukhaWakeDebug` in development for resume/PWA profiling. */
export function DevWakeRecoveryDebug() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  installDevWakeRecoveryDebug();
}